const MODULES = {
  address: 'address_configuration',
  auditTrail: 'audit_trail',
  bank: 'bank_configuration',
  client: 'client',
  company: 'company',
  currency: 'currency',
  department: 'department',
  mail: 'mail_configuration',
  paymentRequest: 'payment_request',
  paymentSettings: 'payment_settings',
  transaction: 'transaction',
  uom: 'uom',
  signature: 'signature_configuration',
  notification: 'notifications',
  report: 'report'
};

export const {
  address,
  auditTrail,
  bank,
  client,
  company,
  currency,
  department,
  mail,
  paymentRequest,
  paymentSettings,
  transaction,
  uom,
  signature,
  notification,
  report
} = MODULES;

const PERMISSION = {
  index: 'index',
  store: 'store',
  show: 'show',
  update: 'update',
  destroy: 'destroy'
};

export const { index, store, show, update, destroy } = PERMISSION;
